import { getUser } from "services/user.service";
import { useQuery  } from "react-query";

export const useUser = (id) => {
  return useQuery(["user", id], () => getUser(id), {
    keepPreviousData: true,
    staleTime: 60 * 60 * 1000,
  });
};
